<template>
  <div>
    <div v-for="(ext, index) in extList" :key="`${index}_ext`">
      <template v-if="extType(ext, 'banner')">
        <BannersHomeSlider v-if="ext.banner_type === 'slider'" :ext="ext" />
        <BannersTwoInRow v-else-if="ext.banner_type === 'two_row'" :ext="ext" />
        <BannersBigCategories v-else-if="ext.banner_type === 'grid'" :ext="ext" />
        <BannersBrands v-else-if="ext.banner_type === 'four_row'" :ext="ext" />
        <BannersUsers v-else-if="ext.banner_type === 'one_row'" :ext="ext" />
        <InfoCardsBig v-else-if="ext.banner_type === 'three_row'" :ext="ext" />
      </template>
      <template v-else-if="extType(ext, 'product')">
        <CarouselProducts :ext="ext" />
      </template>
      <template v-else-if="extType(ext, 'categories')">
        <CarouselPopularProducts :ext="ext" />
      </template>
      <template v-else-if="extType(ext, 'post')">
        <CarouselPosts :ext="ext" />
      </template>
      <template v-else-if="extType(ext, 'seo')">
        <SeoBlock :ext="ext" />
      </template>
    </div>
  </div>
</template>
<script>
import BannersHomeSlider from '@/components/modules/BannersHomeSlider'
import BannersBigCategories from '@/components/modules/BannersBigCategories'
import BannersUsers from '@/components/modules/BannersUsers'
import InfoCardsBig from '@/components/modules/InfoCardsBig'
import CarouselProducts from '@/components/modules/CarouselProducts'
import CarouselPopularProducts from '@/components/modules/CarouselPopularProducts'
import CarouselPosts from '@/components/modules/CarouselPosts'
import SeoBlock from '@/components/modules/SeoBlock'
import BannersBrands from '@/components/modules/BannersBrands'
import BannersTwoInRow from '@/components/modules/BannersTwoInRow'

export default {
  components: {
    BannersHomeSlider,
    BannersBigCategories,
    BannersTwoInRow,
    BannersBrands,
    BannersUsers,
    InfoCardsBig,
    CarouselProducts,
    CarouselPopularProducts,
    CarouselPosts,
    SeoBlock
  },
  props: {
    extensions: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      show_more: false
    }
  },
  computed: {
    extList () {
      return this.extensions.length ? [...this.extensions].sort((a, b) => a.position - b.position) : this.extensions
    }
  },
  methods: {
    extType (ext, type) {
      return ext.type === type
    }
  }
}
</script>
